// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductFacetList":"ec_a bhb_g","ProductFacetList__pill":"ec_b"};